/**
 * Size Selector using Swiper.js library
 * Creates a horizontal swiper for size options using the Swiper library
 */
document.addEventListener('DOMContentLoaded', function() {
  // Initialize the slider on page load.
  initSizeSwiper();

  // On Size location change: update swiper js instances
  document.addEventListener('sizeScaleUpdated', function() {
    // Check if Swiper is available.
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper.js is not loaded. Size selector swiper initialization skipped.');
      return;
    }
    
    // Find all size input wrappers.
    const sizeWrappers = document.querySelectorAll('.variant-options__size .size-inputs-wrapper');
    if (!sizeWrappers.length) return;

    sizeWrappers.forEach(wrapper => {
      const existingSwiperContainer = wrapper.querySelector('.swiper.size-swiper-container');
      if(existingSwiperContainer && existingSwiperContainer.swiper) existingSwiperContainer.swiper.update();
    })
  });

  // When genderUpdated fires, wait a bit (for potential DOM changes) and update disabled slides.
  document.addEventListener('genderUpdated', function() {
    // Select all size swiper containers.
    const swiperContainers = document.querySelectorAll('.swiper.size-swiper-container');
  
    // Fade out all swiper containers.
    swiperContainers.forEach(swiperContainer => {
      swiperContainer.style.transition = 'opacity 0s ease';
      swiperContainer.style.opacity = '0';
    });
  
    // After the fade-out is complete, update the disabled slides and fade in again.
    setTimeout(() => {
      swiperContainers.forEach(swiperContainer => {
        // If the swiper instance provides the updateDisabledSlides function, call it.
        if (
          swiperContainer.swiper &&
          typeof swiperContainer.swiper.updateDisabledSlides === 'function'
        ) {
          swiperContainer.swiper.updateDisabledSlides();
        }
      });
  
      // Fade in the swiper containers.
      swiperContainers.forEach(swiperContainer => {
        swiperContainer.style.transition = 'opacity 0.5s ease';
        swiperContainer.style.opacity = '1';
      });
    }, 100);
  });
  
});

/**
 * Initialize (or rebuild) the size swiper using Swiper.js.
 * This function always destroys any existing Swiper instance in a wrapper and rebuilds it
 * from the current set of radio inputs and labels.
 */
function initSizeSwiper() {
  // Check if Swiper is available.
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper.js is not loaded. Size selector swiper initialization skipped.');
    return;
  }
  
  // Find all size input wrappers.
  const sizeWrappers = document.querySelectorAll('.variant-options__size .size-inputs-wrapper');
  if (!sizeWrappers.length) return;
  
  sizeWrappers.forEach(function(wrapper) {
    // If a Swiper instance exists in this wrapper, destroy it and remove its markup.
    const existingSwiperContainer = wrapper.querySelector('.swiper.size-swiper-container');
    if (existingSwiperContainer && existingSwiperContainer.swiper) {
      existingSwiperContainer.swiper.destroy(true, true);
      // Remove the slider container and any navigation buttons.
      existingSwiperContainer.remove();
      const navButtons = wrapper.querySelectorAll('.size-swiper-button-prev, .size-swiper-button-next');
      navButtons.forEach(btn => btn.remove());
    }
    
    // Gather the current radio inputs and associated labels (which have been dynamically updated).
    const sizeInputs = Array.from(wrapper.querySelectorAll('input[type="radio"]'));
    let activeSlideIndex = 0;

    // Use the updated selector to determine the active gender.
    const activeGender = document.querySelector('section[data-active-gender]')?.getAttribute('data-active-gender') || 'men';
    let storedSize = null;
    if (activeGender.toLowerCase() === 'men') {
      storedSize = sessionStorage.getItem('selectedMenSize');
    } else if (activeGender.toLowerCase() === 'women') {
      storedSize = sessionStorage.getItem('selectedWomenSize');
    }

    let swiperHTML = '<div class="swiper size-swiper-container"><div class="swiper-wrapper">';
    
    // Create a slide for each visible size option.
    sizeInputs.forEach(function(input, index) {
      // Get the label for this input.
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (!label) return;

      // Check if the stored size matches this input value.
      if (storedSize && input.value === storedSize) {
        input.checked = true;
        activeSlideIndex = index;
        input.click();
      }
      
      // Build the slide markup.
      swiperHTML += `
        <div class="swiper-slide size-swiper-slide" data-input-id="${input.id}">
          ${input.outerHTML}
          ${label.outerHTML}
        </div>`;
    });
    
    swiperHTML += '</div></div>';
    swiperHTML += '<div class="size-swiper-button-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></div>';
    swiperHTML += '<div class="size-swiper-button-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg></div>';
    
    // Replace the wrapper content with the new Swiper HTML structure.
    wrapper.innerHTML = swiperHTML;
    
    // Get the necessary elements for Swiper.
    const swiperContainer = wrapper.querySelector('.size-swiper-container');
    const prevButton = wrapper.querySelector('.size-swiper-button-prev');
    const nextButton = wrapper.querySelector('.size-swiper-button-next');
    const slides = wrapper.querySelectorAll('.swiper-slide');
    
    // Initialize Swiper.
    try {
      const swiper = new Swiper(swiperContainer, {
        slidesPerView: 'auto',
        spaceBetween: 5,
        slidesPerGroup: 1,
        initialSlide: activeSlideIndex,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        grabCursor: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        on: {
          init: function() {
            console.log('Size Swiper initialized with ' + this.slides.length + ' slides');

            // Fade in the size wrapper
            const swiperEl = this.el;
            const sizeWrapper = swiperEl.closest('.size-inputs-wrapper');
            if (sizeWrapper) {
              sizeWrapper.style.opacity = '1';
            }
          }
        },
        breakpoints: {
          // when window width is >= 320px
          320: {
            spaceBetween: 5
          },
          420: {
            spaceBetween: 5
          },
          520: {
            spaceBetween: 5
          },
          768: {
            spaceBetween: 0
          },
          990: {
            spaceBetween: 0
          },
          1180: {
            spaceBetween: 0
          }
        }
      });
      
      // Set up event listeners on each slide's radio input.
      slides.forEach(function(slide) {
        const input = slide.querySelector('input[type="radio"]');
        if (input) {
          input.addEventListener('change', function() {
            // Sync the change to the original input.
            const originalInput = document.getElementById(input.id);
            if (originalInput && originalInput !== input) {
              originalInput.checked = true;
              originalInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            // Slide to the changed slide.
            const slideIndex = Array.from(slides).indexOf(slide);
            swiper.slideTo(slideIndex);

            // Use the updated selector to get the active gender from the section.
            const activeGender = document.querySelector('section[data-active-gender]')?.getAttribute('data-active-gender') || 'men';
            const selectedSize = input.value; // assuming input.value holds the size

            // Store the size in sessionStorage under separate keys for men and women.
            if (activeGender.toLowerCase() === 'men') {
              sessionStorage.setItem('selectedMenSize', selectedSize);
            } else if (activeGender.toLowerCase() === 'women') {
              sessionStorage.setItem('selectedWomenSize', selectedSize);
            }
          });
        }
      });
     
      // Auto-slide to the currently selected size, if any.
      const checkedInput = wrapper.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        const slide = checkedInput.closest('.swiper-slide');
        if (slide) {
          const slideIndex = Array.from(slides).indexOf(slide);
          swiper.slideTo(slideIndex);
        }
      }

      // Define a function that updates the disabled state of slides.
      function updateDisabledSlides() {
        swiper.slides.forEach(slide => {
          const input = slide.querySelector('input[type="radio"]');
          const label = slide.querySelector('label');
          if (input && label) {
            if (window.getComputedStyle(input).display === 'none' ||
                window.getComputedStyle(label).display === 'none') {
              slide.classList.add('disabled-slide');
            } else {
              slide.classList.remove('disabled-slide');
            }
          }
        });
        // Refresh the swiper dimensions in case slide sizes changed.
        swiper.update();
      }
      
      // Attach the updateDisabledSlides function to the swiper instance.
      swiper.updateDisabledSlides = updateDisabledSlides;
      
      // Call the update function initially.
      updateDisabledSlides();
      
    } catch (error) {
      console.error('Error initializing Swiper:', error);
      // Optionally, handle the error here.
    }
  });
}